import { SelectOption } from '@iveco-ti/iveco-ds'

import { ApplicationWithUserAccess } from './useManageApplicationAccountUser'

export function useAccountOptionsForApplicationAccountUser(
  userApplication: ApplicationWithUserAccess,
) {
  const ACCOUNT_OPTIONS: SelectOption[] =
    userApplication.application.ApplicationAccount.map((account) => ({
      label: account.Account.title,
      value: account.Account.id,
    }))

  const AVAILABLE_ACCOUNT_OPTIONS: SelectOption[] = ACCOUNT_OPTIONS.filter(
    (account) =>
      !userApplication.access.some(
        (access) => access?.Account?.id === account.value,
      ),
  )

  const getAccountOptionsForUserApplicationAccount = (
    accountIdSelected?: string,
  ) => {
    const selectedOption = ACCOUNT_OPTIONS.find(
      (option) => option.value === accountIdSelected,
    )

    if (!selectedOption) return AVAILABLE_ACCOUNT_OPTIONS

    return AVAILABLE_ACCOUNT_OPTIONS.concat(selectedOption)
  }

  return {
    AVAILABLE_ACCOUNT_OPTIONS,
    getAccountOptionsForUserApplicationAccount,
  }
}
